import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  table: {
    '& .table-root': {
      boxShadow: 'none',
      width: '100%',
      maxHeight: 'calc(100% - 3rem)',
      backgroundColor: 'transparent !important'
    },

    '& .table-row:hover': {
      backgroundColor: 'transparent !important'
    },

    '& .table-head, .table-data, .table-row': {
      border: 'none !important'
    },

    '& .wrapper': {
      overflow: 'unset !important'
    },

    '& .table-row > div.table-head:first-child': {
      paddingLeft: '0 !important'
    }
  }
}))

export default useStyles
